export default __webpack_public_path__ + "img/home-circle.2001bc1d.svg";